<template>
  <div class="calcTrader" id="webterminal" >
  </div>
</template>

<script>
import { useMainStore } from "@/store";
export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
 
  mounted() {
    // setTimeout({
    new window.MetaTraderWebTerminal( "webterminal", { version: 4, servers: ["AAAFx-FX-Demo","AAAFx-FX-Real"], server: "AAAFx-FX-Demo", utmCampaign: "", utmSource: "www.aaafx.com/global", startMode: "create_demo", language: "en", colorScheme: "black_on_white" })
  },
};
</script>
